import { createApp } from 'vue'
import App from './app.vue'

// Vuetify
import 'vuetify/styles'
import { createVuetify, type ThemeDefinition } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import { loadFonts } from './plugins/webfontloader'
import '@mdi/font/css/materialdesignicons.css'
import { createAuth0 } from '@auth0/auth0-vue'

loadFonts()

const lundochTheme: ThemeDefinition = {
  dark: false,
  colors: {
    background: '#e8ecf2',
    surface: '#FFFFFF',
    primary: '#243551',
    'primary-darken-1': '#0D0E23',
    secondary: '#03DAC6',
    'secondary-darken-1': '#018786',
    error: '#B00020',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FB8C00',
  },
}

const vuetify = createVuetify({
  components,
  directives,
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi,
    },
  },
  theme: {
    defaultTheme: "lundochTheme",
    themes: {
      lundochTheme,
    },
  }
})

const app = createApp(App)
  .use(vuetify)
  .use(createAuth0({
    domain: import.meta.env.VITE_AUTH0_DOMAIN,
    clientId: import.meta.env.VITE_AUTH0_CLIENT_ID,
    authorizationParams: {
      redirect_uri: window.location.origin, // + '/callback',
      audience: import.meta.env.VITE_AUTH0_AUDIENCE,
    },
  }));

app.mount('#app');
